const Star = (props) => (
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  {...props}
  >
    <path
      d="M366.578 156.241C367.504 149.776 375.438 147.164 380.057 151.826L418.569 191.266L418.586 191.285L418.605 191.304C422.264 194.954 427.469 196.713 432.655 195.792L486.989 186.398L486.999 186.396C493.316 185.287 498.243 191.822 495.476 197.628L495.338 197.904L469.773 246.745L469.766 246.757C468.58 249.041 467.963 251.577 467.966 254.151C467.969 256.724 468.592 259.259 469.783 261.54L469.79 261.552L495.468 310.334C498.51 316.138 493.635 322.907 487.112 321.853L487.111 321.854L432.772 312.588C427.81 311.724 422.679 313.254 419.041 316.819L418.694 317.17L380.293 356.678L380.284 356.687C375.769 361.362 367.753 358.81 366.804 352.294L366.803 352.292L358.821 297.769L358.82 297.762C358.055 292.6 354.795 288.181 350.177 285.805L350.147 285.788L350.116 285.774L300.647 261.393L300.635 261.387L300.365 261.25C295.156 258.465 294.84 251.168 299.552 247.829L300.63 247.295L350.012 222.814L350.013 222.815C354.697 220.542 358.023 216.02 358.719 210.785L358.721 210.785L366.577 156.243L366.578 156.241Z"
      fill="white"
      stroke="white"
      stroke-width="8"
    />
    <path
      d="M343.373 145.966L48.0858 146.306ZM260.004 254.56L-46.0321 254.914ZM341.135 363.078L62.8179 363.4ZM300.067 314.533L146.54 314.711ZM299.93 195.74L102.392 195.968Z"
      fill="white"
    />
    <path
      d="M343.373 145.966L48.0858 146.306M260.004 254.56L-46.0321 254.914M341.135 363.078L62.8179 363.4M300.067 314.533L146.54 314.711M299.93 195.74L102.392 195.968"
      stroke="white"
      stroke-width="8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default Star;
